import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { isSFTCabinetsGroup } from '../../../helpers/sqftNavigationHelper';
//import CustomSizeSwitcher from "./Attributes/CustomSizeSwitcher";
//import CustomSize from "./Attributes/CustomSize";
import Handles from "./Attributes/Handles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {FormattedMessage} from "react-intl";
import Hinges from "./Attributes/Hinges";
import workspaceControllers from "../../canvas/store/workspaceControllers";
import workspace from "../../canvas/core/workspace";
import {setFeaturePicker, setSQFTActiveShapeId} from "../../../../../actions/sqftMenuFunctions";
import SectionCustomBox from "./Attributes/SectionCustomBox";
import SectionCustomSize from "./Attributes/SectionCustomSize";
import SectionImage from "./Attributes/SectionImage";
import SectionCabinetInterior from "./Attributes/SectionCabinetInterior";
import OpenDoorsSwitcher from "./Attributes/OpenDoorsSwitcher";
import DoorExtensionSwitcher from "./Attributes/DoorExtensionSwitcher";
import {FEATURES_WITH_DISABLED_RESIZING} from "../../../constants";
import {isShapeTallCabinet} from "../../../helpers/sqftCabinetsDataMapper";
import {is3DMode} from "../NavigationHelper";
import {getShape3dModelUrl} from "../../../helpers/sqft3dArHelper";
import {getCabinetSectionsFromModel} from "../../ar3d/threeD/glbViewer/scene/modelsLoader/cabinetInterior/cabinetSectionsParser";
//import CabinetPreview from "./Attributes/CabinetPreview";
//import CustomSizeSwapButton from "./Attributes/CustomSizeSwapButton";

const SqftCabinetAttributes = (props) => {
  const {sqftActiveShapeId, setSQFTActiveShapeId, featurePicker, setFeaturePicker} = props;
  const [, setShapeSizeVersion] = useState(0);
  const [, setDoorExtensionVersion] = useState(0);
  const [hasEditableCabinetInterior, setHasEditableCabinetInterior] = useState(false);
  const isCabinet = isSFTCabinetsGroup();
  const shape = workspace.getShapeById(sqftActiveShapeId);
  const isTallCabinet = Boolean(shape && isShapeTallCabinet(shape));

  useEffect(() => {
    let cancelled = false;

    setHasEditableCabinetInterior(false);

    if (!isTallCabinet) {
      return undefined;
    }

    const modelUrl = getShape3dModelUrl(shape);
    getCabinetSectionsFromModel(modelUrl).then((sections) => {
      if (!cancelled) {
        setHasEditableCabinetInterior(Boolean(sections && sections.length));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [shape, isTallCabinet]);

  if (!isCabinet || !sqftActiveShapeId) {
    if (featurePicker.isOpen) {
      setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
    }
    return null;
  }

  const handleClose = () => {
    setSQFTActiveShapeId(null);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  };

  const existingHinges = workspaceControllers.hinge.getAllResourcesForTheShape(sqftActiveShapeId);
  if (existingHinges.length) {
    void existingHinges
  }

  const featureName = shape.getFeature()?.getFeatureName();
  const isResizingEnabled = !FEATURES_WITH_DISABLED_RESIZING.includes(featureName);
  const isDoorExtensionEnabled = isTallCabinet && shape.shapeCabinet.getDoorExtensionEnabled();

  const refreshCabinetAttributes = () => {
    setShapeSizeVersion((version) => version + 1);
  };
  const refreshDoorExtensionAttributes = () => {
    setDoorExtensionVersion((version) => version + 1);
  };

  return (
    <div className="sr">
      <div className="sr__header">
        <span className="sr__title">
          <FormattedMessage id="attributes"/>
        </span>
        <IconButton aria-label={{}}
                    className="look-icon look-icon--super-tiny look-icon--gray5 sr__close-button"
                    onClick={ handleClose }>
          <CloseIcon className="close-icon"/>
        </IconButton>
      </div>

      <div className="sr__content">
        {/* Original Cabinet Image and Dimensions */}
        <SectionImage shape={shape} />

        {/* Enable Custom Size */}
        { isResizingEnabled ? <SectionCustomSize shape={shape} refreshCabinetAttributes={refreshCabinetAttributes} /> : null }

        { is3DMode() && hasEditableCabinetInterior ? <OpenDoorsSwitcher /> : null }

        { hasEditableCabinetInterior ? (
          <DoorExtensionSwitcher
            shape={shape}
            onChange={refreshDoorExtensionAttributes}
          />
        ) : null }

        {/* Tall Cabinet Interior Layout (sections: cabinets, shelves, drawers) */}
        { hasEditableCabinetInterior ? (
          <SectionCabinetInterior
            key={shape.id}
            shape={shape}
            isDoorExtensionEnabled={isDoorExtensionEnabled}
          />
        ) : null }

        {/* Add as custom box */}
        <SectionCustomBox shape={shape} />

        {/* Hinge Selection */}
        <Hinges/>

        {/* Handle Selection */}
        <Handles />

      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker
});

const mapDispatchToProps = {
  setSQFTActiveShapeId,
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftCabinetAttributes);
